import classNames from 'classnames';

export const getClasses = function (bannerInfo , isApp) {
  let bannerEnabled = false;
  if (bannerInfo) {
    bannerEnabled = bannerInfo.enabled;
  }
  if (isApp) {
    return classNames('fixed-content', {'fixed-content--banner': bannerEnabled});
  }
  return classNames('page-title', {'page-title--banner-top': bannerEnabled});
};